/** Shared header strip height so all ChatV2 columns’ border-bottom align (Figma). */
export const CV2_COLUMN_HEADER_HEIGHT = 64;

export const CHAT_NAV_SIDEBAR_WIDTH = {
  xs: 224,
  xl: 260,
  xxl: 280,
};

export const CHAT_LIST_WIDTH = 280;

export const CHAT_FILTERS = [
  { id: "all", label: "All", view: "Chats" },
  { id: "unassigned", label: "Unassigned", view: "UnAssigned" },
  { id: "closed", label: "Closed", view: "Archive" },
];

/** Map ChatBar internal view → URL tab param */
export const VIEW_TO_TAB = {
  Chats: "",
  UnAssigned: "unassigned",
  Archive: "archive",
};

export const TAB_TO_VIEW = {
  unassigned: "UnAssigned",
  archive: "Archive",
  closed: "Archive",
  all: "Chats",
};
